import { AnyAction, combineReducers } from 'redux';

import { SUPPLIER_DETAIL_RESET } from './supplier-detail-actions';
import {
    SupplierAttributeMappingReducerState,
    supplierAttributeMappingReducer,
} from '../attribute-mapping/store/supplier-attribute-mapping-reducers';
import {
    SupplierCategoryMappingReducerState,
    supplierCategoryMappingReducer,
} from '../category-mapping/store/supplier-category-mapping-reducer';
import {
    SupplierConditionsReducerState,
    supplierConditionsReducer,
} from '../conditions/store/supplier-conditions-reducer';
import {
    SupplierDetailDocumentsReducerState,
    supplierDetailDocumentsReducer,
} from '../documents/store/supplier-detail-documents-reducer';
import {
    SupplierDetailOverviewReducerState,
    supplierDetailOverviewReducer,
} from '../overview/store/supplier-detail-overview-reducers';
import { SupplierEmployeeReducerState, supplierEmployeeReducer } from '../employees/store/supplier-employee-reducer';
import {
    SupplierUnitMappingReducerState,
    supplierUnitMappingReducer,
} from '../unit-mapping/store/supplier-unit-mapping-reducers';
import {
    supplierExternalCustomerMappingReducer,
    supplierExternalCustomerMappingReducerState,
} from '../external-customer-mapping/store/supplier-external-customer-mapping-reducer';

export interface SupplierDetailReducerState {
    overview: SupplierDetailOverviewReducerState;
    attributes: SupplierAttributeMappingReducerState;
    categories: SupplierCategoryMappingReducerState;
    units: SupplierUnitMappingReducerState;
    employees: SupplierEmployeeReducerState;
    documents: SupplierDetailDocumentsReducerState;
    conditions: SupplierConditionsReducerState;
    supplierExternalCustomerMappings: supplierExternalCustomerMappingReducerState;
}

const combinedSupplierDetailReducer = combineReducers<SupplierDetailReducerState>({
    attributes: supplierAttributeMappingReducer,
    categories: supplierCategoryMappingReducer,
    overview: supplierDetailOverviewReducer,
    units: supplierUnitMappingReducer,
    employees: supplierEmployeeReducer,
    documents: supplierDetailDocumentsReducer,
    conditions: supplierConditionsReducer,
    supplierExternalCustomerMappings: supplierExternalCustomerMappingReducer,
});

const initialSupplierDetailReducerState: SupplierDetailReducerState = combinedSupplierDetailReducer(undefined, {
    type: '',
});

export const supplierDetailReducer = (
    state: SupplierDetailReducerState = initialSupplierDetailReducerState,
    action: AnyAction
): SupplierDetailReducerState => {
    switch (action.type) {
        case SUPPLIER_DETAIL_RESET:
            return combinedSupplierDetailReducer(undefined, action);
        default:
            return combinedSupplierDetailReducer(state, action);
    }
};
